export const GET_DAILY_LECTURE_REQUEST = "GET_DAILY_LECTURE_REQUEST";
export const GET_DAILY_LECTURE_SUCCESS = "GET_DAILY_LECTURE_SUCCESS";
export const GET_DAILY_LECTURE_FAILURE = "GET_DAILY_LECTURE_FAILURE";

export const SET_LECTURE_REQUEST = "SET_LECTURE_REQUEST";
export const SET_LECTURE_SUCCESS = "SET_LECTURE_SUCCESS";
export const SET_LECTURE_FAILURE = "SET_LECTURE_FAILURE";

export const GET_SEARCH_LECTURES_REQUEST ="GET_SEARCH_LECTURES_REQUEST";
export const GET_SEARCH_LECTURES_SUCCESS ="GET_SEARCH_LECTURES_SUCCESS";
export const GET_SEARCH_LECTURES_FAILURE ="GET_SEARCH_LECTURES_FAILURE";

export const GET_ADMIN_LECTURE_REQUEST = "GET_ADMIN_LECTURE_REQUEST";
export const GET_ADMIN_LECTURE_SUCCESS = "GET_ADMIN_LECTURE_SUCCESS";
export const GET_ADMIN_LECTURE_FAILURE = "GET_ADMIN_LECTURE_FAILURE";

export const EDIT_LECTURE_REQUEST = "EDIT_LECTURE_REQUEST";
export const EDIT_LECTURE_SUCCESS = "EDIT_LECTURE_SUCCESS";
export const EDIT_LECTURE_FAILURE = "EDIT_LECTURE_FAILURE";

export const SET_BULK_LECTURE_REQUEST = "SET_BULK_LECTURE_REQUEST";
export const SET_BULK_LECTURE_SUCCESS = "SET_BULK_LECTURE_SUCCESS";
export const SET_BULK_LECTURE_FAILURE = "SET_BULK_LECTURE_FAILURE";

export const POST_SEARCH_ADMIN_LECTURE_REQUEST="POST_SEARCH_ADMIN_LECTURE_REQUEST";
export const POST_SEARCH_ADMIN_LECTURE_SUCCESS="POST_SEARCH_ADMIN_LECTURE_SUCCESS";
export const POST_SEARCH_ADMIN_LECTURE_FAILURE="POST_SEARCH_ADMIN_LECTURE_FAILURE";

export const GET_ALL_LECTURE_REQUEST = "GET_ALL_LECTURE_REQUEST";
export const GET_ALL_LECTURE_SUCCESS = "GET_ALL_LECTURE_SUCCESS";
export const GET_ALL_LECTURE_FAILURE = "GET_ALL_LECTURE_FAILURE";